// import React, { useEffect } from "react";
// import fbIcon from '../images/facebook.png';
// import ytIcon from '../images/youtube.png';

// // Single-file React component with injected CSS to avoid separate .css parsing issues.
// export default function IDCardBack({ data = {} }) {
// 	const defaultData = {
// 		logo: "https://via.placeholder.com/120x40?text=Ujala+Logo",
// 		dob: "15/07/1995",
// 		bloodGroup: "N/A",
// 		email: "example@mail.com",
// 		address:
// 			"Mahipal Singh, rasoopur dhira, Sambhal sarai tarin, Uttar Pradesh - 244303",
// 		notes: [
// 			"This card is completely unpaid.",
// 			"The institute does not allow any further offenses to hurt anyone's sentiments.",
// 			"If the Identity Card is lost, immediately inform the ujala office.",
// 			"You will comply with all the above conditions.",
// 			"Failure to do so may result in action taken against you.",
// 		],
// 		blueLine: "सम्बंधित कार्य के लिए संस्थान के निर्देशों का पूर्ण रूप से पालन करें।",
// 		offices: [
// 			"Head Office: C-55 Block Arandi Road, Indra Nagar, Lucknow-226016",
// 			"Corp. Office: Pari Chowk, Parthala Khangerpur,Noida-201304",
// 			"RTO Office: Budh Vihar,Avas Vikas, Moradabad-244001",
// 		],
// 		officeEmail: "E-mail : moradabadujalanews@gmail.com",
// 		fbLogo: "https://via.placeholder.com/18?text=F",
// 		ytLogo: "https://via.placeholder.com/18?text=Y",
// 		fbText: "मुरादाबाद उजाला न्यूज़",
// 		ytText: "मुरादाबाद उजाला न्यूज़",
// 		website: "https://moradabadujala.in",
// 		contact: "0591-3561303, 8449000034",
// 	};

// 	const d = { ...defaultData, ...data };

// 	// Inject CSS into document head so there is no separate CSS file to parse (avoids missing-semicolon errors)
// 	useEffect(() => {
// 		const styleId = "idcardback-injected-styles";
// 		if (typeof document === "undefined") return;
// 		if (document.getElementById(styleId)) return;
// 		const css = `
// /* IDCardBack CSS - injected */
// .idcard-container {
// 	padding: 12px;
// 	display: flex;
// 	justify-content: center;
// }

// .idcard-frame {
// 	width: 340px;
// 	// background: white;
// 	border: 1px solid #999;
// 	border-radius: 8px;
// 	overflow: hidden;
//     height: 550px;
// }

// .idcard-inner {
// 	background: #fff8c7ff;
// 	margin: 6px;
// 	padding: 10px;
// 	border-radius: 6px;
// 	display: flex;
// 	flex-direction: column;
// 	gap: 6px;
// }

// .logo-wrap img {
// 	height: 55px;
// 	object-fit: contain;
// 	display: block;
// 	margin: 0 auto;
// }

// .top-fields {
// 	display: flex;
// 	flex-direction: column;
// 	gap: 6px;
// 	font-size: 11px;
// 	margin-top: 0px;
// }

// /* render each left-field child as a label:value row */
// .left-fields > div {
// 	display: flex;
// 	gap: 8px;
// 	align-items: center;
// }
// .left-fields .label {
// 	font-weight: 700;
// 	color: #555;
// 	min-width: 110px;
// }
// .left-fields .value {
// 	font-weight: 600;
// }
// .left-fields .dob {
// 	color: red;
// 	font-weight: 700;
// }

// .right-fields { margin-top: -4pxpx; }
// .address-value {
// 	font-size: 10px;
// 	line-height: 1.2;
// 	font-weight: 600;
// }

// .separator {
// 	border-top: 1px solid gray;
// 	// margin: 6px 0;
//     margin-top: 4px;
// }

// .notes-title {
// 	font-weight: 700;
// 	font-size: 10px;
//     margin-top: -4px;
// }

// .notes-list {
// 	margin-top: -4px;
// 	font-size: 10px;
// 	margin-bottom: 1px;
// 	padding-left: 20px;
//     font-weight: 600;
// }

// .blue-strip {
// 	background: #0a4bb6;
// 	color: white;
// 	padding: 3px;
// 	font-size: 8px;
//     margin-top: -4px;
     

// }


// .office-box {
// 	background: white;
// 	border: 1px solid #aaa;
// 	padding: 6px;
// 	font-size: 10px;
//     font-weight: 600;
// }

// .office-box .office-heading {
// 	color: #2f9c63; /* light green heading */
// 	font-weight: 700;
// 	font-size: 10px;
// 	margin-bottom: 4px;
// }

// .email-strip {
// 	background: black;
// 	color: white;
// 	padding: 6px;
// 	font-size: 10px;
// }

// .footer {
// 	background: red;
// 	color: white;
// 	padding: 6px;
// 	border-radius: 4px;
// 	font-size: 10px;
//     margin-top: -4px;
// }

// .footer-row {
// 	display: flex;
// 	justify-content: space-between;
// 	margin-bottom: 4px;
// }

// .icon-text {
// 	display: flex;
// 	align-items: center;
// 	gap: 6px;
// }

// 	.icon-svg {
// 	width: 20px;
// 	height: 14px;
// 	display: inline-block;
// 	vertical-align: middle;
    
// }
// `;
// 		const s = document.createElement("style");
// 		s.id = styleId;
// 		s.appendChild(document.createTextNode(css));
// 		document.head.appendChild(s);
// 		return () => {
// 			const el = document.getElementById(styleId);
// 			if (el) el.remove();
// 		};
// 	}, []);

// 	return (
// 		<div className="idcard-container">
// 			<div className="idcard-frame">
// 				<div className="idcard-inner">

// 					{/* Logo */}
// 					<div className="logo-wrap">
// 						<img src={d.logo} alt="logo" />
// 					</div>

// 					{/* Top Fields */}
// 					<div className="top-fields">
// 						<div className="left-fields">
// 							<div>
// 								<div className="label">DOB</div>
// 								<div className="value dob">{d.dob}</div>
// 							</div>
// 							<div>
// 								<div className="label">Blood Group</div>
// 								<div className="value">{d.bloodGroup}</div>
// 							</div>
// 							<div>
// 								<div className="label">E-mail</div>
// 								<div className="value email">{d.email}</div>
// 							</div>
// 						</div>

// 						<div className="right-fields">
// 							<div className="label">Address</div>
// 							<div className="address-value">{d.address}</div>
// 						</div>
// 					</div>

// 					<div className="separator" />

// 					{/* Notes */}
// 					<div className="notes-title">Note :</div>
// 					<ol className="notes-list">
// 						{d.notes.map((n, i) => (
// 							<li key={i}>{n}</li>
// 						))}
// 					</ol>

// 					{/* Blue Strip */}
// 					<div className="blue-strip"><div className="strip-text">{d.blueLine}</div></div>

// 					{/* Offices */}
// 					<div className="office-box">
// 						{/* <div className="office-heading">Head Offices</div> */}
// 						{d.offices.map((o, i) => (
// 							<div key={i}>{o}</div>
// 						))}
// 					</div>

// 					{/* Office Email */}
// 					<div className="email-strip">
// 						<div>{d.officeEmail}</div>
// 						<div>E-mail : example@gmail.com</div>
// 					</div>

// 					{/* Footer */}
// 					<div className="footer">
// 						<div className="footer-row">
// 							<div className="icon-text">
// 									<img src={fbIcon} className="icon-svg" alt="fb" />
// 									<span style={{marginLeft:6}}>{d.fbText}</span>
// 								</div>

// 								<div className="icon-text">
// 									<img src={ytIcon} className="icon-svg" alt="yt" />
// 									<span style={{marginLeft:6}}>{d.ytText}</span>
// 								</div>
// 						</div>
// 						<div>Website: {d.website}</div>
// 						<div>Contact: {d.contact}</div>
// 					</div>
// 				</div>
// 			</div>
// 		</div>
// 	);
// }


import React, { useEffect } from "react";
import fbIcon from '../images/facebook.png';
import ytIcon from '../images/youtube.png';

export default function IDCardBack({ data = {} }) {

    const defaultData = {
        logo: "https://via.placeholder.com/120x40?text=Ujala+Logo",
        dob: "15/07/1995",
        bloodGroup: "N/A",
        email: "example@mail.com",
        address:
            "Mahipal Singh, rasoopur dhira, Sambhal sarai tarin, Uttar Pradesh - 244303",
        notes: [
            "This card is completely unpaid.",
            "The institute does not allow any further offenses to hurt anyone's sentiments.",
            "If the Identity Card is lost, immediately inform the ujala office.",
            "You will comply with all the above conditions.",
            "Failure to do so may result in action taken against you.",
        ],
        blueLine: "इस कार्ड के अनुचित प्रयोग किए जाने पर संस्थान की कोई जिम्मेदारी नहीं होगी।",
        offices: [
            "Head Office: C-85 Block Arabali Road, Indra Nagar, Lucknow-226016",
            "Corp. Office: Pari Chowk, Parthala Khangerpur,Noida-201304",
            "RTO Office: Buddhi Vihar,Avas Vikas, Moradabad-244001",
        ],
        officeEmail: "E-mail : rrnewsfastestupdate@gmail.com",
        fbText: "RR NEWS TV FASTEST UPDATE",
        ytText: "RR NEWS TV FASTEST UPDATE",
        website: "www.rrnewstv.com",
        contact: "+91 7983697306, 8979916908",
    };

    const d = { ...defaultData, ...data };

    useEffect(() => {
        const styleId = "idcardback-injected-styles";
        if (document.getElementById(styleId)) return;

        const css = `
/* FIXED SIZE TO MATCH FRONT CARD */
.idcard-container {
    padding: 12px;
    display: flex;
    justify-content: center;
}

.idcard-frame {
    width: 380px !important;   /* <-- CHANGED from 340px */
    min-width: 380px !important;
    max-width: 380px !important;
    height: 560px !important;
    border: 1px solid #999;
    border-radius: 8px;
    overflow: hidden;
    border:10px solid black;
}

.idcard-inner {
    background: #fff8c7ff;
    margin: 6px;
    padding: 10px;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    
}

/* LOGO */
.logo-wrap img {
    height: 60px;
    object-fit: contain;
    display: block;
    margin: 0 auto;
}

/* TOP FIELDS */
.top-fields {
    display: flex;
    flex-direction: column;
    gap: 6px;
    font-size: 11px;
}

.left-fields > div {
    display: flex;
    gap: 8px;
    align-items: center;
}
.label {
    font-weight: 700;
    color: #555;
    min-width: 110px;
}
.value {
    font-weight: 600;
}
.dob {
    color: red;
    font-weight: 700;
}

.address-value {
    font-size: 10px;
    font-weight: 700;
    line-height: 1.2;
}

/* SEPARATOR */
.separator {
    border-top: 1px solid gray;
    margin-top: 4px;
}

/* NOTES */
.notes-title {
    font-weight: 700;
    font-size: 10px;
}
.notes-list {
    font-size: 10px;
    padding-left: 20px;
    font-weight: 700;
    margin-top: -2px;
}

/* BLUE STRIP */
.blue-strip {
    background: #f72100;
    color: white;
    padding: 3px;
    font-size: 10px;
    margin-top: 4px;
    height: 20px;
}
.strip-text { text-align: center;
margin-top: -8px;
}


/* OFFICES */
.office-box {
    background: white;
    border: 1px solid #aaa;
    padding: 4px;
    font-size: 10px;
    font-weight: 700;
    height: 60px;
}
    .office-text{
        margin-top: -3px;}

/* EMAIL STRIP */
.email-strip {
    background:linear-gradient(to right, rgb(5, 1, 37), rgb(46, 34, 115));
    color: white;
    font-weight: 700;
    padding: 6px;
    font-size: 12px;
    height: 55px;
}
    .email-text{
        margin-top: -5px;}
        .email-text-2{
            margin-top: -8px;}

/* FOOTER */
.footer {
   background:linear-gradient(to right, rgb(5, 1, 37), rgb(46, 34, 115));
    color: white;
    padding: 6px;
    border-radius: 4px;
    font-size: 13px;
    margin-top: -4px;
}

.footer-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 4px;
}

.icon-text {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 8px;
    font-weight: 700;
}
.icon-svg {
    width: 20px;
    height: 14px;
    display: inline-block;
}
`;

        const s = document.createElement("style");
        s.id = styleId;
        s.textContent = css;
        document.head.appendChild(s);

        return () => {
            const el = document.getElementById(styleId);
            if (el) el.remove();
        };
    }, []);

    return (
        <div className="idcard-container">
            <div className="idcard-frame">
                <div className="idcard-inner">

                    {/* Logo */}
                    <div className="logo-wrap">
                        <img src={d.logo} alt="logo" />
                    </div>

                    {/* TOP FIELDS */}
                    <div className="top-fields">
                        <div className="left-fields">
                            <div>
                                <div className="label">DOB</div>
                                <div className="value dob">{d.dob}</div>
                            </div>

                            <div>
                                <div className="label">Blood Group</div>
                                <div className="value">{d.bloodGroup}</div>
                            </div>

                            <div>
                                <div className="label">E-mail</div>
                                <div className="value">{d.email}</div>
                            </div>
                        </div>

                        <div className="right-fields">
                            <div className="label">Address</div>
                            <div className="address-value">{d.address}</div>
                        </div>
                    </div>

                    <div className="separator" />

                    {/* NOTES */}
                    <div className="notes-title">Note :</div>
                    <ol className="notes-list">
                        {d.notes.map((n, i) => (
                            <li key={i}>{n}</li>
                        ))}
                    </ol>

                    {/* BLUE STRIP */}
                    <div className="blue-strip">
                        <div className="strip-text">{d.blueLine}</div>
                    </div>

                    {/* OFFICE ADDRESSES */}
                    <div className="office-box">
                        {d.offices.map((o, i) => (
                            <div className="office-text" key={i}>{o}</div>
                        ))}
                    </div>

                    {/* EMAIL SECTION */}
                    <div className="email-strip">
                        <div className="email-text">{d.officeEmail}</div>
                        <div className="email-text-2">E-mail : support@rrnewstv.com</div>
                    </div>

                    {/* FOOTER */}
                    <div className="footer">
                        <div className="footer-row">
                            <div className="icon-text">
                                <img src={fbIcon} className="icon-svg" alt="fb" />
                                <span>{d.fbText}</span>
                            </div>

                            <div className="icon-text">
                                <img src={ytIcon} className="icon-svg" alt="yt" />
                                <span>{d.ytText}</span>
                            </div>
                        </div>

                        <div>Website: {d.website}</div>
                        <div>Contact: {d.contact}</div>
                    </div>

                </div>
            </div>
        </div>
    );
}


